/* eslint-disable react-hooks/exhaustive-deps */
import { Autocomplete, Box, Button, LinearProgress, TextField } from '@mui/material';
import axios from 'axios'; 
import { useState, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { useSelector } from 'react-redux';
import { AppState } from 'src/store/Store';
import { apiConfig } from 'src/config/apiConfig';
import { useTranslation } from 'react-i18next';

export const Autocomplete_InstantFetch: any = ({
  //
  list,
  setList,
  selectedItem,
  setSelectedItem,
  fetchApiEndPoint,
  createNewItem,
  createNewItem_SetFunction,
  variant = 'standard',
  label,
  disabled,
  isRequired,
  isRequiredHelper = false,
  desiredDisplayKey,
  sx,
}: any) => {
  const [targetValue, setTargetValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [firstrender, setfirstrender] = useState(true);

  const [cookie] = useCookies();
  const language_redux = useSelector((state: AppState) => state.customizer.isLanguage);
  const { t } = useTranslation<'translation'>();

  const fetchData = async (searchValue?: string) => {
    if (searchValue && typeof searchValue !== 'string') return;
    setLoading(true);

    try {
      let response: any | null = null;
      if (searchValue) {
        response = await axios.get<{ data: any }>(apiConfig.API_URL + fetchApiEndPoint + `&search=${searchValue?.trim() ? searchValue : ''}` + `&ordering=${desiredDisplayKey ? desiredDisplayKey : '-id'}`, {
          headers: {
            'X-CSRFToken': cookie.csrftoken,
          },
          withCredentials: true,
        });
      } else {
        response = await axios.get<{ data: any }>(apiConfig.API_URL + fetchApiEndPoint, {
          headers: {
            'X-CSRFToken': cookie.csrftoken,
          },
          withCredentials: true,
        });
      }
      setList(response.data.data);
    } catch (error) {
      console.error(`Error fetching ${fetchApiEndPoint}:`, error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (targetValue !== '') {
      setList([]);
      fetchData(targetValue);
      setfirstrender(false);
    }
  }, [targetValue]);

  useEffect(() => {
    if (selectedItem) {
      setTargetValue(getDisplayText(selectedItem));
    }
    // if (!selectedItem) {
    //   setTargetValue('');
    // }
    // fetchData(targetValue);
  }, [selectedItem, list]);

  const getDisplayText = (item: any): string => {
    //^ Newest update, test with a clear mind later:
    if (Array.isArray(item)) {
      return item.join('');
    }
    //^____
    if (typeof item === 'object') {
      let displayProperties: any | any[] = null;

      if (desiredDisplayKey) {
        displayProperties = [desiredDisplayKey];
      } else {
        displayProperties = ['display_name', 'name', 'first_name', 'last_name', 'title', 'title&path'];
      }
      const validProperty: any = displayProperties?.find((prop) => prop in item) || '';

      if (desiredDisplayKey === 'title&path') {
        return item['title'] + (item['template'] ? ` (${item['template'].split('/')?.slice(5)})` : '') || '';
      } else if (desiredDisplayKey && desiredDisplayKey in item) {
        return item[desiredDisplayKey] || '';
      } else if (validProperty === 'first_name') {
        return item[validProperty] + ' ' + item['last_name'] || '';
      } else {
        return item[validProperty] || '';
      }
    }
    return item ? JSON.stringify(item) : '';
  };

  if (list) {
    return (
      <Autocomplete
        id={`autocomplete-${fetchApiEndPoint}`}
        clearOnEscape
        options={list}
        getOptionLabel={(option: any) => getDisplayText(option)}
        // getOptionLabel={(option: any) => (fetchApiEndPoint.includes(authgroups_api) && language_redux === 'tr' ? turkish_authgroups(getDisplayText(option)) : getDisplayText(option))}
        // getOptionLabel={(option: any) => {
        //   const label = language_redux === 'tr' ? translate_api_res(getDisplayText(option), fetchApiEndPoint) : getDisplayText(option);
        //   return label || '';
        // }}
        value={selectedItem}
        onChange={(_, newValue) => {
          setTargetValue(newValue);
          setSelectedItem(newValue || null);
        }}
        disabled={disabled ? disabled : false}
        // sx={{ minWidth: '150px', width: '100%', maxHeight: '20px', height: '20px', padding: 0 }}
        sx={{
          '& .MuiInputBase-root': {
            minWidth: '150px',
            width: '100%',
            minHeight: '44px', // Set minimum height for the input
            padding: '0', // Remove padding
            '& .MuiAutocomplete-input': {
              padding: '0px 8px', // Adjust padding inside the input
            },
          },
          '& .MuiOutlinedInput-root': {
            minHeight: '44px', // Ensure the outlined input wrapper respects the height
            padding: '0', // Remove padding
            '& fieldset': {
              padding: '0', // Remove padding from the fieldset
            },
          },
          ...sx,
        }}
        onInputChange={(_, newInputValue) => {
          setTargetValue(newInputValue);
        }}
        renderOption={(props, option) => (
          //? This helps to prevent this error: React keys must be passed directly to JSX without using spread.
          (<li {...props} key={option.id || option[desiredDisplayKey] || Math.random()}>
            {getDisplayText(option)}
          </li>)
        )}
        // renderInput={(params) => <TextField variant={variant} {...params} />}
        renderInput={(params) =>
          isRequired && !selectedItem && isRequiredHelper ? (
            <TextField variant={variant} {...params} required={isRequired ? isRequired : false} helperText={isRequired ? t('Required') : null} label={label || undefined} />
          ) : (
            (<TextField variant={variant} {...params} required={isRequired ? isRequired : false} label={label || undefined} />) /* urlToProperWords(fetchApiEndPoint) */
          )
        }
        noOptionsText={
          createNewItem ? (
            <div style={{ padding: '5px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '10px', width: '100%' }}>
              {loading ? (
                <Box sx={{ width: '100%' }}>
                  <LinearProgress />
                </Box>
              ) : !loading && !list?.length ? (
                firstrender ? (
                  t('Type for results...')
                ) : (
                  t('no_item_is_found')
                )
              ) : null}
              <Button variant="outlined" color={'secondary'} sx={{ height: '36px', width: 'min-content', whiteSpace: 'nowrap' }} onClick={createNewItem_SetFunction}>
                + {t('Create one')}
              </Button>
            </div>
          ) : (
            <Box sx={{ width: '100%' }}>{loading ? <LinearProgress /> : !loading && !list?.length ? firstrender ? t('Type for results...') : t('no_item_is_found') : null}</Box>
          )
        }
      />
    );
  }
};
